module.exports = __webpack_public_path__ + "static/content-2-img-8eb138a29b6ee54d048977e9e7ef5bf4.png";